import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import { CircularProgress, Grid, Tab } from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Paper from '@material-ui/core/Paper';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import Alert from '@material-ui/lab/Alert';
import AuthorizedElement from '@security/AuthorizedElement';
import CartoesTableView from '@pages/Escola/Cartoes/componentes/CartoesTableView';
import PendenciaTableView from '@pages/Pendencia/PendenciaTableView';
import DocumentoEnvioTableView from './componentes/DocumentoEnvioTableView';
import OutrosDocumentosObjetoPostalTableView from './componentes/OutrosDocumentosObjetoPostalTableView';
import InformacaoObjetoPostal from './componentes/InformacaoObjetoPostal';

import Breadcrumbs from '@base/Breadcrumbs';
import Subtitle from '@base/Subtitle';
import Title from '@base/Title';
import Toast from '@base/Toast';
import ButtonPrimary from "@base/Button";
import ObjetoPostalService from '@services/ObjetoPostalService';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { ProcessoResolver } from '@helpers/ProcessoHelper';
import LabelIntruso from "../../base/LabelIntruso";
import DialogConfirm from "../../base/Dialog/DialogConfirm";

export const ConteudoObjetoPostal = (props) => {
  const toastRef = useRef(null);
  const params = useParams();
  const [tabValue, setTabValue] = useState(params.intruso === undefined ? "0" : params.intruso);
  const [horaUltimoRefresh, setHoraUltimoRefresh] = useState();
  const [objetoPostal, setObjetoPostal] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogReinicializacao, setOpenDialogReinicializacao] = useState(false);
  const [loading,setLoading] = useState(false);
  const processo = ProcessoResolver(params.processo);
  const pageName = `${params.codigoObjetoPostal}`;

  const breadcrumbs = [
    {
      path: "/" + processo.id + "/objetosPostais" + (params.intruso === undefined ? '' : "ComIntrusos") ,
      name: `Objetos Postais ${params.intruso === undefined ? '' : " com Cartões intrusos"}`
    }
  ];

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const carregaInformacoesDoObjetoPostal = useCallback(() => {
    setObjetoPostal(null);
    if (processo.id && params.codigoObjetoPostal) {
      ObjetoPostalService.getByProcessoAndNumeroObjetoPostal(processo.id, params.codigoObjetoPostal)
        .then(resposta => {console.log(resposta.data);
           setObjetoPostal(resposta.data)})
        .catch(error => console.log(error));

        setLoading(false);
    }
  }, [processo, params.codigoObjetoPostal]);

  useEffect(() => carregaInformacoesDoObjetoPostal(), [carregaInformacoesDoObjetoPostal]);

  function atualizarStatus(idObjetoPostal, finalizacaoManual) {
    setLoading(true);
		ObjetoPostalService.finalizar(processo.id, idObjetoPostal).then(resultado => {
			toastRef.current.show("success", "Objeto postal atualizado.");
      carregaInformacoesDoObjetoPostal();
      setOpenDialog(false)
		});
	}

  function reinicializarObjeto(idObjetoPostal) {
    setLoading(true);
		ObjetoPostalService.reinicializar(processo.id, idObjetoPostal).then(resultado => {
			toastRef.current.show("success", "Objeto postal reinicializado com sucesso.");
      carregaInformacoesDoObjetoPostal();
      setOpenDialogReinicializacao(false)
		});
	}

  return (
    <>
      <Toast ref={toastRef} />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Breadcrumbs links={breadcrumbs} active={pageName} />
        </Grid>
      </Grid>

      {objetoPostal &&
        <>
          <Title style={{ fontWeight: '600',display:'inline-block' }}>{objetoPostal.codigoPostal}</Title>
          <Subtitle style={{marginLeft:20,display:"inline"}}>
            {objetoPostal.escolaDoObjetoPostal ? `${objetoPostal.escolaDoObjetoPostal.nome} / ${objetoPostal.escolaDoObjetoPostal.codigoInep}` : ''}
          </Subtitle>

          {objetoPostal.status === "FINALIZADO" &&
            <Grid container spacing={3} style={{ marginBottom: 12 }}>
              <Grid item xs={12}>
                <Alert severity="success">
                  <b>Status:</b> Finalizado
                </Alert>
              </Grid>
            </Grid>
          }

          <Paper spacing={2} elevation={1}>
            <Grid item container>
              <Grid item sm={12} lg={12}>
                <TabContext value={tabValue}>
                  <TabList onChange={handleChange} indicatorColor="primary" textColor="primary" variant="fullWidth">
                    <Tab label="Informações" value="0" />
                    <Tab label="Cartões" value="1" />
                    <Tab label="DE's" value="2" />
                    <Tab label="Pendências" value="3" />
                    <Tab label="Outros Documentos" value="4" />
                  </TabList>

                  <TabPanel value="0">
                    <InformacaoObjetoPostal objeto={objetoPostal} processo={processo} />
                  </TabPanel>

                  <TabPanel value="1">
                    {objetoPostal.escolas && objetoPostal.escolas.length > 0 &&
                      objetoPostal.escolas.map(escola =>
                        <>
                        <Paper elevation={0}>
                          <Grid alignItems="center" container>
                            <Subtitle>{escola.nome}
                              {objetoPostal.escolaDoObjetoPostal != null && escola.codigoInep !== objetoPostal.escolaDoObjetoPostal.codigoInep ?
                                 <LabelIntruso/>
                                 
                               
                                 
                                 : <></>
                              }
                            </Subtitle>

                            <CartoesTableView
                              refresh={horaUltimoRefresh}
                              exibeCheckboxes={objetoPostal.podeTransferirCartao}
                              escola={escola.codigoInep}
                              exibeFiltro={false}
                              permiteDigitarCartao={false}
                              permiteTransferirCartao={true}
                              filtroObjetoPostal={params.codigoObjetoPostal}

                              processo={processo.id}
                              permiteDescartarCartao={true}
                              aoDescartarCartao={(cartao) => setHoraUltimoRefresh(new Date())}
                              motivosDescarteDisponiveis={() => {
                                return [
                                  { value: 'DESCLASSIFICADO', label: 'Desclassificado' },
                                  { value: 'DUPLICADO', label: 'Duplicado' },
                                  { value: 'OUTRO', label: 'Outro' }
                                ];
                              }}
                              aoRestaurarCartao={(cartao) => setHoraUltimoRefresh(new Date())}
                              permiteTranferenciaEmLoteDeCartoes={objetoPostal.podeTransferirCartao}
                              aoTransferir={(cartao) => carregaInformacoesDoObjetoPostal()}
                            />
                          </Grid>
                        </Paper>
                        <br/>
                        </>
                      )

                    }

                    {objetoPostal.possuiCartoesSemEscola &&

                    <Paper elevation={0}>
                    <Grid alignItems="center" container>
                      <Subtitle>Sem vínculo com escola</Subtitle>
                      <CartoesTableView
                            exibeCheckboxes={true}
                            filtroComEscolaAssociada={false}
                            exibeFiltro={false}
                            permiteDigitarCartao={false}
                            permiteTransferirCartao={true}
                            filtroObjetoPostal={params.codigoObjetoPostal}

                            processo={processo.id}
                            permiteDescartarCartao={true}
                            aoDescartarCartao={(cartao) => setHoraUltimoRefresh(new Date())}
                            motivosDescarteDisponiveis={() => {
                              return [
                                { value: 'DESCLASSIFICADO', label: 'Desclassificado' },
                                { value: 'DUPLICADO', label: 'Duplicado' },
                                { value: 'OUTRO', label: 'Outro' }
                              ];
                            }}
                            aoRestaurarCartao={(cartao) => setHoraUltimoRefresh(new Date())}
                            permiteTranferenciaEmLoteDeCartoes={true}
                            aoTransferir={(cartao) => carregaInformacoesDoObjetoPostal()}
                            permiteHandleChecks={false}
                          />
                        </Grid>
                      </Paper>}

                  </TabPanel>

                  <TabPanel value="2">
                    <Grid alignItems="center" container>
                      <Grid item sm={12}>
                        <DocumentoEnvioTableView
                          exibeFiltro={false}
                          size={50}
                          processo={processo.id}
                          filtros={[{ "field": "objetoPostal", "value": params.codigoObjetoPostal }]}
                        />
                      </Grid>
                    </Grid>
                  </TabPanel>

                  <TabPanel value="3">
                    <Grid alignItems="center" container>
                      <Grid item sm={12}>
                        <PendenciaTableView
                          exibeFiltro={false}
                          ocultaNomeEscola={true}
                          ocultaObjetoPostal={true}
                          size={50}
                          processo={processo.id}
                          filtros={[{ "field": "objetoPostal", "value": params.codigoObjetoPostal }]}
                        />
                      </Grid>
                    </Grid>
                  </TabPanel>

                 <TabPanel value="4">
                    <Grid alignItems="center" container>
                      <Grid item sm={12}>
                        <OutrosDocumentosObjetoPostalTableView
                          documentos={objetoPostal.outros}
                        />
                      </Grid>
                    </Grid>
                  </TabPanel>


                </TabContext>
              </Grid>
            </Grid>
            {objetoPostal.status !== "FINALIZADO" &&
              <ButtonPrimary
                style={{margin:10, marginLeft:20}}
                onClick={() => setOpenDialog(true)}
                name="Finalizar"
                startIcon={loading ? <CircularProgress size={16} /> : <CheckBoxIcon />}
              
                size="large"
                disabled={loading}
              />
            }

            {objetoPostal.podeReinicializar &&
              <AuthorizedElement roles={["__processo.usuario.administrador"]} >
                <ButtonPrimary
                  style={{margin:10, marginRight:40,float:'right'}}
                  onClick={() => setOpenDialogReinicializacao(true)}
                    variant="outlined"
                  name="Reinicializar"
                  startIcon={loading ? <CircularProgress size={16} /> : <DeleteForeverIcon />}
                  size="large"
                  disabled={loading}
                />
              </AuthorizedElement>
            }

          </Paper>
          {openDialog &&
            <DialogConfirm
              maxWidth={"sm"}
              id={{id: objetoPostal.id}}
              text={"Deseja realmente FINALIZAR o objeto postal ZERADO ou com cartões INTRUSOS? Esta ação requer cuidado" +
                " e só deve ser utilizada quando há certeza que o Objeto Postal não possui cartões ou os cartões realmente pertencem a escola."}
              close={() => setOpenDialog(false)}
              open={openDialog}
              title={"Importante"}
              handleConfirm={() => atualizarStatus(objetoPostal.id, true)}
            />
          }

{openDialogReinicializacao &&
            <DialogConfirm
              maxWidth={"sm"}
              id={{id: objetoPostal.id}}
              text={"Deseja realmente REINICIALIZAR este objeto postal? Esta ação é irreversível e retornará este objeto para a triagem. <br/><br/> <b style='color:red'>- TODOS OS CARTÕES e seus TRATAMENTOS, DEs e PENDÊNCIAS SERÃO REMOVIDOS.</b><br/><br> <b style='color:red'>- ESTE OBJETO DEVE VOLTAR PARA A MESA DE TRIAGEM.</b><br><br> Você confirma essa operação? "}
              close={() => setOpenDialogReinicializacao(false)}
              open={openDialogReinicializacao}
              title={"ATENÇÃO"}
              handleConfirm={() => reinicializarObjeto(objetoPostal.id)}
            />
          }

        </>
      }
    </>
  );
}

export default ConteudoObjetoPostal;
